import { CreateService } from '@/services/service';
import { MissionAnnualEntity } from '@/entities/mission-annual.entity';
import moment from 'moment'

export default class MissionAnnualService extends CreateService<MissionAnnualEntity>(
  'mission-annual',
) {
  async getMissionAnnualByMonthAnhyear(): Promise<MissionAnnualEntity> {
    this.apiBuilder.reset()
    const [rows] = await this.apiBuilder
      .filter('month', '$eq', `${moment().month() + 1}`)
      .filter('year', '$eq', `${moment().year()}`)
      .join(['missionFirst', 'missionSecond', 'missionThird'])
      .getMany();
    return rows[0];
  }
}

export function useMissionAnnualService() {
  return new MissionAnnualService();
}
